/**
 * Created by chenzheyu on 2017/6/16.
 */
import XKuploadMod from './src/uploadMod.vue'

XKuploadMod.install = function (Vue) {
  Vue.component(XKuploadMod.name, XKuploadMod)
}

export default XKuploadMod



// WEBPACK FOOTER //
// ./src/components/module/uploadMod/index.js